import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SettingsComponent } from './components/settings/settings.component';
import { HomeComponent } from './pages/home/home.component';
import { LoginComponent } from './pages/login/login.component';
import { FacturasComponent } from './components/facturas/facturas.component';
import { OrdPagoComponent } from './components/ord-pago/ord-pago.component';
import { MailingComponent } from './components/mailing/mailing.component';
import { CargaFacturasComponent } from './components/facturas-proveedor/carga-facturas/carga-facturas.component';
import { NuevaFacturaComponent } from './components/facturas-proveedor/nueva-factura/nueva-factura.component';
import { authGuardFn } from './core/guards/auth-guard-fn.guard';
import { FacturasProveedoresComponent } from './components/facturas-proveedores/facturas-proveedores.component';


const routes: Routes = [
  {path: 'login', component: LoginComponent},
  {path: 'home', component: HomeComponent, children: [
    {path: '', component: HomeComponent},
    {path: 'facturas', component:FacturasComponent},
    {path: 'op', component:OrdPagoComponent},
    {path: 'settings', component: SettingsComponent},
    {path: 'mailing/pro', component: MailingComponent},
    {path: 'mailing/cli', component: MailingComponent},
    {path: 'proveedores', children: [
        {path: 'carga-fc', component: CargaFacturasComponent},
        {path: 'nueva-fc', component: NuevaFacturaComponent},
    ], canActivate:[authGuardFn], data: { permisos: ['HPOCP'] }}, 
    {path: 'facturas-proveedor', component: FacturasProveedoresComponent, canActivate:[authGuardFn], data: { permisos: ['HMCP'] }}, 
  ]},

{path:'**', redirectTo: 'login', pathMatch:'full'}
    
  ];

@NgModule({
  imports: [RouterModule.forRoot(routes), RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
